const config = {
  checkUrl: `/user`,
  sendBeat: `/analytics`,
  sendVerify: `/verify`,
};

export default config;
